import React from 'react';

import Show from 'components/Show';
import Editor from 'components/Editor';
import { Textarea } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import Option from 'containers/Student/Exams/Profile/View/Option';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Question = ({ idx, type, noTitle, question }) => {
	// Use exam's student store
	const [slug, onChange, onChangeWord] = useExamStudentStore(state => [
		state.exam.slug,
		state.onChange,
		state.onChangeWord
	]);

	// Handle onChange on answer
	const onAnswer = (change) => onChange(question.id, change);

	// Handle onChange on word
	const onWordChange = (change) => onChangeWord(question.id, change);

	return (
		<div key={question.id} className="flex flex-col gap-1">
			{/* Show title only if more than one question */}
			<Show if={!noTitle}>
				<Title title={`${idx + 1}. jautājums`} />
			</Show>

			{/* Question's description */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				type="spellcheck"
				value={question?.content}
				spellcheck={{
					mode: 'answer',
					words: question?.words,
					onWordChange: onWordChange
				}}
			/>

			{/* Question's answer on multiple or essay */}
			<Show if={['multiple', 'essay'].includes(type)}>
				<Textarea
					name="answer"
					value={question?.answer}
					onChange={onAnswer}
					label="Atbilde"
					inputClassName="min-h-[5.8rem]"
				/>
			</Show>

			{/* Question's answer on connect */}
			<Show if={type === 'connect'}>
				<div className="space-y-2">
					<div>Atbilde</div>

					{question?.connections?.map(connection =>
						<div key={connection.id}>{connection.answer}</div>
					)}
				</div>
			</Show>

			{/* Question's option list */}
			<Show if={type === 'quiz'}>
				<div className="mt-2 flex flex-col gap-4">
					{question.options?.map(option =>
						<Option key={option.id} questionId={question.id} option={option} />
					)}
				</div>
			</Show>
		</div>
	);
};

export default Question;